import { createFileRoute } from "@tanstack/react-router";

import { useDeployment } from "../../../app/deployment";
import { BillingPage } from "../../../features/billing/billing-page";
import { LicencePage } from "../../../features/billing/licence-page";

/** SaaS: plan and billing. A dedicated instance (B-65) has a licence instead. */
function BillingOrLicence() {
  const deployment = useDeployment();
  return deployment?.mode === "dedicated" ? <LicencePage /> : <BillingPage />;
}

export const Route = createFileRoute("/_app/settings/billing")({ component: BillingOrLicence });
